<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de {{ termKey.SectorPlural | term }}</h1>
    </div>
    <br />
    <div class="card-header">
      <button id="" class="primary-button" appPermision="/sector+c" (click)="createSector()">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncSector | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let sector">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/sector+u"
                    (click)="updateSector(sector)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a appOnlysuperuser="/sector" (click)="eliminate(sector)" class="icon-button">
                    <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let sector">
                {{ sector.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let sector">
                {{ sector.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="objective">
              <th mat-header-cell *matHeaderCellDef>Objetivo</th>
              <td mat-cell *matCellDef="let sector">
                {{ sector.objective }}
              </td>
            </ng-container>

            <ng-container matColumnDef="risk">
              <th mat-header-cell *matHeaderCellDef>Riesgo</th>
              <td mat-cell *matCellDef="let sector">
                {{ sector.risk }}
              </td>
            </ng-container>

            <ng-container matColumnDef="component">
              <th mat-header-cell *matHeaderCellDef>Componente</th>
              <td mat-cell *matCellDef="let sector">
                {{ sector.component?.name }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchSector($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
